<template>
	<div v-if="user" class="btn-toolbar pull-left" role="toolbar">
		<div v-if="showActionCompleted || showActionDestroy || showActionNotification || showActionClose" class="btn-group" role="group" aria-label="...">
			<div class="dropdown">
				<button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown">
					Acción
					<span class="caret"></span>
				</button>
				<ul class="dropdown-menu">
					<li v-if="showActionCompleted" @click="action('completed')">
						<a class="link">
							<i class="ti-check-box"></i>
							Completar
						</a>
					</li>
					<li v-if="showActionDestroy" @click="action('destroy')">
						<a class="link">
							<i class="icon-trash"></i>
							Eliminar
						</a>
					</li>
					<li v-if="showActionNotification" @click="action('notification')">
						<a class="link">
							<i aria-hidden="true" class="fa fa-paper-plane"></i>
							Notificar
						</a>
					</li>
					<li v-if="showActionClose" @click="action('close')">
						<a class="link">
							<i class="ti-check-box"></i>
							Cerrar
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import Ladda from 'ladda'
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				selected: null,
			}
		},
		computed: {
			showActionClose() {
				var status = this.$route.params.status
				if(status == 'ended') {
					if(this.user.hasRole(['manager', 'admin'])) {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			},
			showActionCompleted() {
				var status = this.$route.params.status
				if(status == 'processing') {
					if(this.user.hasRole(['manager', 'admin', 'staff'])) {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			},
			showActionDestroy() {
				var status = this.$route.params.status
				if(status == 'pending' || status == 'assigned') {
					if(this.user.hasRole(['manager', 'admin'])) {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			},
			showActionNotification() {
				var status = this.$route.params.status
				if(status == 'assigned') {
					if(this.user.hasRole(['manager', 'admin'])) {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			},
		},
		methods: {
			action(action) {
				var that = this
				if(this.selected.length) {
					swal.queue([{
						title: that.$t("messages.attention"),
						text: that.$t("messages.actions_be_applied_selected_items"),
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						allowOutsideClick: false,
						preConfirm: function () {
							return new Promise(function (resolve) {
								var data = {
									selected: that.selected,
									action: action,
								}
								that.$http.post('admin/projects/tasks/actions', data)
								.then(response => {
									that.$emit('reload')
									swal(response.body.title, response.body.text, response.body.type);
								}).catch(function(response) {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								})
							})
						}
					}]).catch(swal.noop)
				}
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/tasks/views/Action.vue